module.exports = __webpack_public_path__ + "img/gonzalo.8e85a53e.png";